var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEraser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 10.3159C21 10.1584 20.9367 10.0078 20.8238 9.89661L14.5184 3.67373C14.2847 3.44209 13.9042 3.44209 13.6697 3.67373L3.75565 13.4733C3.26804 13.9536 3 14.5929 3 15.274C3 15.9543 3.26843 16.5928 3.75565 17.0731L7.05176 20.3251C7.10724 20.3803 7.17384 20.4239 7.24791 20.4544C7.32096 20.4842 7.3987 20.5 7.47685 20.5H19.5918C19.9232 20.5 20.192 20.2344 20.192 19.907C20.192 19.5796 19.9232 19.314 19.5918 19.314H12.1424L20.8242 10.7352C20.9367 10.624 21 10.4734 21 10.3159ZM7.72476 19.314L4.60351 16.2338C4.34368 15.9774 4.20029 15.6369 4.20029 15.2732C4.20029 14.9103 4.3433 14.569 4.60351 14.3126L6.83256 12.1093L11.3067 16.5303C11.4239 16.6461 11.5774 16.704 11.731 16.704C11.8845 16.704 12.0381 16.6461 12.1553 16.5303C12.3897 16.2986 12.3897 15.9234 12.1553 15.6917L7.68119 11.2707L14.0948 4.93159L19.5508 10.3159L10.4451 19.314H7.72476Z",
    fill: "#1752AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraser);
export default __webpack_public_path__ + "static/media/Eraser.5b8b28e76d16b806a7732a3fc2f5f3e2.svg";
export { ForwardRef as ReactComponent };